export const RECAPTCHA_SETTINGS = {
  siteKey: '6LeeGGogAAAAAFxVZek-2oUJlel8w_QKfXlaoFkd'
};
